import {Box, Center, Container, Image, Spinner, Text} from "@chakra-ui/react";
import React, { memo, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import {Navigate, useNavigate, useParams} from "react-router-dom";

import {getTestByPublicId, postAnswer, postTestStart} from "../../shared/Api";
import { useAuthentication } from "../../shared/hooks/AuthenticationProvider";
import {enableBlurProtection} from "../../shared/hooks/BlurProtection";
import {useTheme} from "../../shared/hooks/ThemeProvider";
import { Authority, CandidateStatus, Paths } from "../../shared/model/Constants";
import { publicKeys } from "../../shared/QueryKeys";
import {
  allowOptionsShuffle,
  disableKeyCommands,
  extractData,
  shuffleArray
} from "../../shared/Utils";
import Question from "./Question";
import TestEnd from "./TestEnd";
import TestStart from "./TestStart";

const Test = () => {
  const navigate = useNavigate();
  function navigateHome() {
    navigate(Paths.HOME);
  }
  // const [started, setStarted] = useState<boolean>(true);
  const params = useParams<{
    publicId: string;
    candidateToken: string;
  }>();
  const queryClient = useQueryClient();
  const publicId = params.publicId || "";
  const candidateToken = params.candidateToken || "";

  const [oldQuestion, setOldQuestion] = useState<String>("");


  disableKeyCommands();
  enableBlurProtection();

  const testQuery = useQuery(publicKeys.testsByPublicId(publicId), () =>
    getTestByPublicId(publicId, candidateToken).then(extractData),
    {retry: false, refetchOnMount: false, refetchOnReconnect: false,
      onSettled: (data, error) => {
        if (data === undefined || data.id === undefined) {
          navigateHome();
        }
      },
    }
  );

  const startTestMutation = useMutation(
    ({ publicId }: any) => postTestStart(publicId, candidateToken),
    {
      onSuccess: () =>
        queryClient.invalidateQueries(publicKeys.testsByPublicId(publicId)),
      onSettled: (data) => {
        if (data === undefined || data.status === 404) {
          navigateHome();
        }
      },
    }
  );

  const postAnswerMutation = useMutation(
    ({ publicId, questionId, optionIds, timesPlayed, timeLeft }: any) =>
      postAnswer(publicId, questionId, optionIds, timesPlayed, timeLeft, candidateToken),
    {
      onSuccess: () =>
        queryClient.invalidateQueries(publicKeys.testsByPublicId(publicId)),
      onSettled: (data) => {
        if (data === undefined || data.status === 404) {
          navigateHome();
        }
      },
    }
  );

  if (testQuery.isError) {
    return <Navigate to={Paths.ERROR} />;
  } else if (!testQuery.data || testQuery.isFetching) {
    return (
      <Center height="200px">
        <Spinner />
      </Center>
    );
  } else {
    if (testQuery.data.status.status === CandidateStatus.INVITED) {
        // if (started) {
        return (
            <TestStart
                test={testQuery.data}
                isLoading={startTestMutation.isLoading}
                onTestStart={() => startTestMutation.mutate({publicId})}
            />
        );
        // } else {
        //     return (<ConfirmStart evaluationType={testQuery.data.evaluationType}/>);
        // }
    } else if (
      testQuery.data.status.status === CandidateStatus.TEST_IN_PROGRESS &&
      testQuery.data.nextQuestion
    ) {
      //if (!postAnswerMutation.isLoading) {
      // prevent shuffle of current questions
      if (!testQuery.isLoading && (oldQuestion !== testQuery.data.nextQuestion.text) && allowOptionsShuffle(testQuery.data.nextQuestion)) {
        testQuery.data.nextQuestion.options = shuffleArray(testQuery.data.nextQuestion.options);
        setOldQuestion(testQuery.data.nextQuestion.text);
      }
      // <TimerComponent minutes={30}/>
      return (
        <Question
          test={testQuery.data}
          status={testQuery.data.status}
          isLoading={postAnswerMutation.isLoading}
          onNextQuestion={(optionIds: string[], timeLeft: number) =>
            postAnswerMutation.mutate({
              publicId,
              questionId: testQuery.data.nextQuestion.id,
              optionIds,
              timesPlayed: testQuery.data.nextQuestion.timesPlayed,
              timeLeft: timeLeft
            })
          }
        />
      );
    } else if (testQuery.data.status.status === CandidateStatus.TEST_COMPLETE) {
      return <TestEnd evaluationType={testQuery.data.evaluationType}
      timerStopped={testQuery.data.timeLimit > 0 && testQuery.data.timeLeft === 0}
                       />;
    } else {
      return <Text>La prueba solicitada no existe</Text>;
    }
  }
};

const RenderTest = () => {
  const theme = useTheme().theme;
  return (
    <Container maxW="container.lg" marginX="auto"
          filter= {'grayscale('+theme.IMG_GRAYSCALE+') contrast('+theme.IMG_CONTRAST+')'}>
      <Box
          bgImage="'/images/img-1e0eab8174642bd1921638f9bd71e94648399338.jpg'"
          bgSize= "cover" bgRepeat= "no-repeat"
          minHeight="610px"  width="100%" height="auto"
          borderWidth='1px' borderRadius='lg'>

        <Box paddingTop={5} />
        <Test/>
        <Box paddingBottom={5} />
        <Image
          src="/images/51b7-15d0-10a4-f7ae.png"
          maxH="6rem" bottom="16px" />
      </Box>
    </Container>
  )
}
// Image position="absolute"
export default memo(RenderTest);
